import {
  SAVE_LOCATION_SITE,
  SAVE_LOCATION_SITE_SUCCESS,
  SAVE_LOCATION_SITE_FAILURE,
  SET_LOCATION_SITE_STORE,
  REMOVE_LOCATION_SITE_STORE,
  SAVE_LOCATION_ENTITY,
} from 'common/types';
import _ from 'lodash';
import {produce} from 'immer';
import {evalDependentDataRules} from 'framework/validation/evalDependentDataRules';
import {getUpdatedReduxState} from 'common/utils';

const initialState = {inventoryItem: {}};
const INVENTORY_ITEM = 'inventoryItem';
// ------------------------------------
// Action Handlers
// ------------------------------------
const ACTION_HANDLERS = {
  [SAVE_LOCATION_SITE]: (state, action) => {
    return {
      ...state,
      loadingInventorySite: true,
    };
  },

  [SAVE_LOCATION_ENTITY]: (state, action) => {
    return produce(state, (draft) => {
      const dataPath = ['data', 'dataPath'];
      const invActionDataPath = _.join([INVENTORY_ITEM, _.get(action, dataPath)], '.');
      const prevData = _.get(draft, invActionDataPath);
      _.set(draft.inventoryItem, action.data.dataPath, action.data.value);
      evalDependentDataRules(
        draft,
        invActionDataPath,
        action.extraProps,
        prevData,
        state.reducers
      );
    });
  },

  [SAVE_LOCATION_SITE_SUCCESS]: (state, action) => {
    return {
      ...state,
      inventoryItem: {
        ...state.inventoryItem,
        reducers: state.reducers,
        errors: action.payload.errors,
      },
      loadingInventorySite: false,
    };
  },
  [SAVE_LOCATION_SITE_FAILURE]: (state, action) => {
    return {
      ...state,
      loadingInventorySite: false,
      error: action.payload.response.message,
    };
  },

  [SET_LOCATION_SITE_STORE]: (state, action) => {
    return {
      ...state,
      inventoryItem: action.data.inventoryItem,
      reducers: action.data.reducers,
    };
  },

  [REMOVE_LOCATION_SITE_STORE]: (state, action) => {
    return initialState;
  },
};

// ------------------------------------
// Reducer
// ------------------------------------
export default (state = initialState, action) => {
  const handler = ACTION_HANDLERS[action.type];
  return handler ? handler(state, action) : state;
};
